import React from 'react'
import styled from 'styled-components'

const Notice = styled.div`
  width: 100%;
  padding: 60px 16px;
  text-align: center;
  font-family: 'TruenoLt', sans-serif;

  h1 {
    color: #005870;
    margin-bottom: 16px;
  }

  p {
    max-width: 560px;
    font-size: 1.1rem;
    line-height: 1.6;
    margin: 0 auto 12px;
  }
`

const MaintenanceNotice = () => (
  <Notice className="maintenance-notice">
    <h1>We&rsquo;ll be right back</h1>
    <p>
      Our website is currently down for maintenance. We&rsquo;re working hard to
      get everything back up and running as soon as possible.
    </p>
    <p>Thank you for your patience. Please check back soon.</p>
  </Notice>
)

export default MaintenanceNotice
